<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.inventories'), $t('text.list')]">
        <el-dropdown
          v-if="Permit.canActionsChargeEdition('mmsInventoryManage')"
          menu-align="start"
          trigger="click"
          class="mgr10"
        >
          <el-button type="success" size="mini">
            {{ $t("action.inventoryCheck") }}
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="warehouse of mmsAuthWarehouses"
              :key="warehouse.id"
            >
              <div
                @click="
                  $router.push('/normal/mms/inventories/check/' + warehouse.id)
                "
              >
                {{ warehouse.name }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          v-if="Permit.canActionsChargeEdition('mmsInventoryManage')"
          menu-align="start"
          trigger="click"
          class="mgr10"
        >
          <el-button type="primary" size="mini">
            {{ $t("action.importInventory") }}
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="warehouse of mmsAuthWarehouses"
              :key="warehouse.id"
            >
              <div
                @click="
                  $router.push('/normal/mms/inventories/import/' + warehouse.id)
                "
              >
                {{ warehouse.name }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-if="mmsAuthWarehouses.length != 0"
          type="default"
          size="mini"
          @click="exportAllData"
          >{{ $t("action.exportAll") }}</el-button
        >
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.keyword"
            :placeholder="$t('material.serialNoName')"
            size="small"
          />
        </el-form-item>
        <el-form-item
          v-if="Permit.canActionsChargeEdition('mmsInventoryManage')"
        >
          <el-select
            v-model="searchForm.supplierId"
            :placeholder="$t('menu.suppliers')"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.shelf"
            :placeholder="$t('menu.shelfs')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky :sticky-top="50" :viewport="1024" :is-rem="false" class="sticky">
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="Permit.canActionsChargeEdition('mmsInventoryApplyPurchase')"
              type="primary"
              size="mini"
              @click="applyPurchase"
              >{{ $t("action.applyPurchase") }}</el-button
            >

            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.downLoadChecked") }}
                </el-dropdown-item>
                <el-dropdown-item command="search">
                  {{ $t("action.downLoadSearch") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :loading="loading"
        id="materialTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="checkbox" type="checkbox" width="35" />
        <vxe-table-column
          field="material.image"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.material.image" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="materialSerialNo"
          :title="$t('material.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.materialSerialNo }}
            <div class="font10">{{ row.material.name }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="material.subjectName"
          :title="$t('material.subject')"
          min-width="80"
        />
        <vxe-table-column
          field="material.color"
          :title="$t('material.color')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.material.color }}

            <div class="font10">{{ row.material.colorNo }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="storeQuantity"
          :title="$t('inventory.inventoryQty')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.material.unit == row.material.inUnit">
              {{ row.storeQuantity }}{{ row.material.unit }}
            </span>
            <span v-else>
              {{ row.storeQuantity }}{{ row.material.unit }} =
              {{ row.inStoreQuantity }}{{ row.material.inUnit }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="cashQuantity"
          :title="$t('material.cashQuantity')"
          min-width="100"
          v-if="Permit.currentTenant().config.mmsInvUseCash == true"
        >
          <template v-slot="{ row }">
            <el-popover
              placement="right"
              width="600"
              trigger="click"
              @show="getStockInOuts(row)"
            >
              <vxe-table
                :data="stockInOuts"
                id="stockInOutsTable"
                row-id="id"
                ref="stockInOutsTable"
                class="recordsTable"
                size="mini"
                resizable
                round
                auto-resize
                highlight-hover-row
              >
                <vxe-table-column field="stockType" min-width="40">
                  <template v-slot="{ row }">
                    <span v-if="row.stockType == 'in'" class="green">入</span>
                    <span v-if="row.stockType == 'out'" class="red">出</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="quantity"
                  :title="$t('text.quantity')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.unit == row.inUnit">
                      {{ row.quantity }}{{ row.unit }}
                    </span>
                    <span v-else>
                      {{ row.quantity }}{{ row.unit }} = {{ row.inQuantity
                      }}{{ row.inUnit }}
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="remainQuantity"
                  :title="$t('inventory.remainQuantity')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.unit == row.inUnit">
                      {{ row.remainQuantity }}{{ row.unit }}
                    </span>
                    <span v-else>
                      {{ row.quantity }}{{ row.unit }} =
                      {{ row.inRemainQuantity }}{{ row.inUnit }}
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="associateSerialNo"
                  :title="$t('notice.serialNo')"
                  min-width="150"
                />
                <vxe-table-column
                  field="remark"
                  :title="$t('text.remark')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <raw-html-limit-number
                      :content="row.remark"
                      :number="6"
                      type="richText"
                    />
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="createdAt"
                  :title="$t('text.createAt')"
                  min-width="110"
                />
              </vxe-table>
              <span slot="reference" class="blue popover-reference font10">
                <span v-if="row.material.unit == row.material.inUnit">
                  {{ row.cashQuantity }}{{ row.material.unit }}
                </span>
                <span v-else>
                  {{ row.cashQuantity }}{{ row.material.unit }} =
                  {{ row.inCashQuantity }}{{ row.material.inUnit }}
                </span>
              </span>
            </el-popover>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="manualLockQuantity"
          :title="$t('inventory.manualLockQuantity2')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.manualLockQuantity != null">
              <span v-if="row.material.unit == row.material.inUnit">
                {{ row.manualLockQuantity }}{{ row.material.unit }}
              </span>
              <span v-else>
                {{ row.manualLockQuantity }}{{ row.material.unit }}=
                {{ row.inManualLockQuantity }}{{ row.material.inUnit }}
              </span>
            </span>

            <div>
              <raw-html-limit-number
                :content="row.manualLockRemark"
                :number="6"
              />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="alertQuantity"
          :title="$t('inventory.warnQuantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.material.unit == row.material.inUnit">
              {{ row.alertQuantity }}{{ row.material.unit }}
            </span>
            <span v-else>
              {{ row.alertQuantity }}{{ row.material.unit }}=
              {{ row.inAlertQuantity }}{{ row.material.inUnit }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('material.outPrice')"
          min-width="90"
          v-if="Permit.canActionsChargeEdition('globalMaterialPrice')"
        >
          <template v-slot="{ row, rowIndex }">
            <i
              v-if="Permit.canActionsChargeEdition('mmsInventoryEditPrice')"
              class="el-icon-edit"
              @click="editPrice(row, rowIndex)"
            />
            {{ row.price | currency4 }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="warehouseName"
          :title="$t('menu.warehouses')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.warehouseName }}
            <div class="font10">{{ $t("menu.shelfs") }}：{{ row.shelf }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="supplierName"
          :title="$t('menu.suppliers')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.material && row.material.defaultSupplier">
              {{ row.material.defaultSupplier.supplierName }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row, rowIndex }">
            <i
              v-if="Permit.canActionsChargeEdition('mmsInventoryManage')"
              slot="reference"
              class="el-icon-edit fl"
              @click="editRemark(row, rowIndex)"
            />
            <raw-html-limit-number
              :content="row.remark"
              :number="6"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="lastCheckAt"
          :title="$t('inventory.lastCheckAt')"
          min-width="110"
        />
        <vxe-table-column
          field="lastInAt"
          :title="$t('inventory.lastInAt')"
          min-width="110"
        />
        <vxe-table-column
          field="lastOutAt"
          :title="$t('inventory.lastOutAt')"
          min-width="110"
        />

        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="140"
          fixed="right"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="Permit.canActionsChargeEdition('mmsInventoryInOutManage')"
              type="text"
              size="mini"
              @click="stockIn(row, rowIndex)"
              >{{ $t("action.stockIn") }}</el-button
            >
            <el-button
              v-if="Permit.canActionsChargeEdition('mmsInventoryInOutManage')"
              type="text"
              size="mini"
              @click="stockOut(row, rowIndex)"
              >{{ $t("action.stockOut") }}</el-button
            >
            <el-dropdown class="mgl10">
              <span class="blue font12">
                {{ $t("text.more") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="Permit.canActionsChargeEdition('mmsInventoryManage')"
                >
                  <div class="font10" @click="edit(row, rowIndex)">
                    {{ $t("text.edit") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    Permit.canActionsChargeEdition('mmsInventoryManage') &&
                    row.storeQuantity == 0 &&
                    row.cashQuantity == 0
                  "
                >
                  <el-popconfirm
                    :title="$t('prompt.confirmDelete')"
                    @confirm="deleteRow(row, rowIndex)"
                  >
                    <div slot="reference" class="font10">
                      {{ $t("text.delete") }}
                    </div>
                  </el-popconfirm>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="Permit.canActionsChargeEdition('mmsInventoryAllocate')"
                >
                  <div class="font10" @click="allocate(row, rowIndex)">
                    {{ $t("stockInType.allocate") }}
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="Permit.canActionsChargeEdition('mmsInventoryManage')"
                >
                  <div
                    class="font10"
                    @click="updateManualLockQuantity(row, rowIndex)"
                  >
                    {{ $t("action.manualLockQuantity") }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 库存快照 -->
    <el-dialog
      :title="$t('action.exportAll')"
      :visible.sync="exportAllDataDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="exportAllDataObjForm" :model="exportAllDataObj">
        <el-form-item
          :prop="'checkedWarehouseIds'"
          :rules="[
            {
              required: true,
              message: $t('rules.select', [$t('menu.warehouses')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-checkbox-group v-model="exportAllDataObj.checkedWarehouseIds">
            <el-checkbox
              v-for="warehouse in mmsAuthWarehouses"
              :key="warehouse.id"
              :label="warehouse.id"
              style="width: 30%"
            >
              <raw-html-limit-number :content="warehouse.name" :number="10" />
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="exportAllDataSubmitDoing"
          size="small"
          @click="exportAllDataSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="exportAllDataDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 申请采购 -->
    <el-dialog
      :title="$t('action.applyPurchase')"
      :close-on-click-modal="false"
      :visible.sync="applyPurchaseDF"
      width="60%"
    >
      <el-form
        ref="applyPurchaseForm"
        :model="applyPurchaseObj"
        label-width="80px"
      >
        <fieldset>
          <legend>{{ $t("menu.suppliers") }}</legend>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('menu.suppliers')"
                :prop="'supplierId'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('menu.suppliers')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model.trim="applyPurchaseObj.supplierId"
                >
                  <el-option
                    v-for="supplier in suppliers"
                    :key="supplier.id"
                    :label="supplier.name"
                    :value="supplier.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="selectDiffSupplierDF" :span="8">
              <el-form-item label-width="10px">
                <span class="center orange">
                  {{ $t("prompt.selectDiffSupplierMaterial") }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("procure.procureItem") }}</legend>
          <vxe-table
            :data="applyPurchaseObj.procureItems"
            class="recordsTable"
            size="mini"
            resizable
            round
            auto-resize
            highlight-hover-row
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="image"
              :title="$t('product.images')"
              width="80"
            >
              <template v-slot="{ row }">
                <thumbnail :images="row.image" />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="materialSerialNo"
              :title="$t('material.serialNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.materialSerialNo }}
                <div class="font10">{{ row.materialName }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="subjectName"
              :title="$t('material.subject')"
              min-width="80"
            />
            <vxe-table-column
              field="color"
              :title="$t('material.color')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.color }}
                <div class="font10">{{ row.colorNo }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="_supplierName"
              :title="$t('menu.suppliers')"
              min-width="80"
            />
            <vxe-table-column
              field="price"
              :title="$t('material.price')"
              min-width="90"
            >
              <template v-slot="{ row }">
                {{ row.price | currency4 }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="quantity"
              :title="$t('text.quantity')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <el-input
                  size="mini"
                  v-model.trim="row.quantity"
                  :placeholder="row.unit"
                >
                  <template slot="append">{{ row.unit }}</template>
                </el-input>
              </template>
            </vxe-table-column>

            <vxe-table-column
              field="remark"
              :title="$t('text.remark')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <el-input size="mini" v-model.trim="row.remark" />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="action"
              :title="$t('text.action')"
              width="50"
            >
              <template v-slot="{ row, rowIndex }">
                <el-button
                  type="text"
                  size="mini"
                  @click="removePurchaseItem(row, rowIndex)"
                >
                  {{ $t("text.remove") }}
                </el-button>
              </template>
            </vxe-table-column>
          </vxe-table>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("text.remark") }}</legend>
          <el-input
            size="small"
            v-model.trim="applyPurchaseObj.remark"
            type="textarea"
            :rows="2"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="applyPurchaseDoing"
          size="small"
          @click="applyPurchaseSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="applyPurchaseDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑价格 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editPriceDF"
      width="30%"
    >
      <el-form ref="editPriceForm" :model="editPriceObj">
        <el-form-item
          :prop="'price'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('material.price')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editPriceObj.price"
            :placeholder="$t('material.price')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editPriceDoing"
          size="small"
          @click="editPriceSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 入库 -->
    <el-dialog
      :title="$t('action.stockIn')"
      :close-on-click-modal="false"
      :visible.sync="stockInDF"
      width="30%"
    >
      <el-form ref="stockInForm" :model="stockInObj" label-width="80px">
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="stockInObj.quantity"
            :placeholder="row && row.material ? row.material.unit : null"
          >
            <template slot="append" v-if="row && row.material">{{
              row.material.unit
            }}</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="stockInObj.remark"
            type="textarea"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="stockInDoing"
          size="small"
          @click="stockInSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="stockInDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 出库 -->
    <el-dialog
      :title="$t('action.stockOut')"
      :close-on-click-modal="false"
      :visible.sync="stockOutDF"
      width="30%"
    >
      <el-form ref="stockOutForm" :model="stockOutObj" label-width="80px">
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="stockOutObj.quantity"
            :placeholder="row && row.material ? row.material.unit : null"
          >
            <template slot="append" v-if="row && row.material">{{
              row.material.unit
            }}</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="stockOutObj.remark"
            type="textarea"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="stockOutDoing"
          size="small"
          @click="stockOutSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="stockOutDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editForm" :model="editObj" label-width="70px">
        <el-form-item
          :prop="'alertQuantity'"
          :label="$t('inventory.alertQuantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('inventory.alertQuantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.alertQuantity"
            :placeholder="row && row.material ? row.material.unit : null"
          >
            <template slot="append" v-if="row && row.material">{{
              row.material.unit
            }}</template>
          </el-input>
        </el-form-item>
        <el-form-item
          :prop="'shelf'"
          :label="$t('menu.shelfs')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.shelfs')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-autocomplete
            size="small"
            v-model.trim="editObj.shelf"
            :fetch-suggestions="querySearchShelfs"
            style="width: 100%"
            @select="handleSelectShelfs"
          />
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('text.remark')"
            v-model="editObj.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 手动锁定库存  -->
    <el-dialog
      :title="$t('action.manualLockQuantity')"
      :visible.sync="updateManualLockQuantityDF"
      width="30%"
    >
      <el-form
        ref="updateManualLockQuantityForm"
        :model="updateManualLockQuantityObj"
        label-width="80px"
      >
        <el-form-item
          :label="$t('inventory.manualLockQuantity')"
          :prop="'manualLockQuantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [
                $t('inventory.manualLockQuantity'),
              ]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="updateManualLockQuantityObj.manualLockQuantity"
            :placeholder="row && row.material ? row.material.unit : null"
          >
            <template slot="append" v-if="row && row.material">{{
              row.material.unit
            }}</template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" :prop="'remark'">
          <el-input
            v-model="updateManualLockQuantityObj.remark"
            :placeholder="$t('text.remark')"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="updateManualLockQuantityDoing"
          size="small"
          @click="updateManualLockQuantitySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="updateManualLockQuantityDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 调拨 -->
    <el-dialog
      :title="$t('stockInType.allocate')"
      :close-on-click-modal="false"
      :visible.sync="allocateDF"
      width="30%"
    >
      <el-form ref="allocateForm" :model="allocateObj" label-width="80px">
        <el-form-item :label="$t('text.type')" :prop="'type'">
          <el-radio-group
            size="small"
            v-model="allocateObj.type"
            @change="selectAllocateType"
          >
            <el-radio-button label="in">
              {{ $t("allocateTypes.in") }}
            </el-radio-button>
            <el-radio-button label="out">
              {{ $t("allocateTypes.out") }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('allocate.applyDepartName')"
          :prop="'applyWarehouseName'"
        >
          {{ allocateObj.applyWarehouseName }}
        </el-form-item>
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="allocateObj.quantity"
            @blur="blurAllocateQuantity"
            :placeholder="row && row.material ? row.material.unit : null"
          >
            <template slot="append" v-if="row && row.material">{{
              row.material.unit
            }}</template>
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('allocate.acceptDepartName')"
          :prop="'acceptWarehouseId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('allocate.acceptDepartName')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="allocateObj.acceptWarehouseId"
            @change="blurAllocateQuantity"
          >
            <el-option
              v-for="invWarehouse in invWarehouses"
              :key="invWarehouse.warehouseId"
              :label="invWarehouse.text"
              :value="invWarehouse.warehouseId"
            />
          </el-select>
        </el-form-item>

        <el-form-item :prop="'remark'" :label="$t('allocate.applyRemark')">
          <el-input
            size="small"
            v-model.trim="allocateObj.applyRemark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="allocateDoing"
          size="small"
          @click="allocateSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="allocateDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑备注 -->
    <el-dialog
      :title="$t('rules.edit', [$t('text.remark')])"
      :close-on-click-modal="false"
      :visible.sync="editRemarkDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input size="small" v-model="editRemarkObj.remark" type="textarea" />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRemarkDoing"
          size="small"
          @click="editRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Util from "@/utils/index.js";

import SupplierMms from "@/api/supplierMms.js";
import SubjectMms from "@/api/subjectMms.js";
import InventoryMms from "@/api/inventoryMms.js";
import Warehouse from "@/api/warehouse.js";
import UserWarehouse from "@/api/userWarehouse.js";
import Procure from "@/api/procure.js";
import AllocateMms from "@/api/allocateMms.js";
import StockInOutMms from "@/api/stockInOutMms.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtmlLimitNumber,
  },
  data() {
    return {
      Util: Util,

      narrows: [
        [
          {
            label: this.$t("inventory.unCheck"),
            items: InventoryMms.ooCheckTimes,
          },
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("inventory.alertQuantity"),
                key: "yes",
                condition: { alert: "yes" },
              },
              {
                label: this.$t("inventory.storeQuantity") + "<=0",
                key: 'lessYes',
                condition: { less: 'yes' },
              },
              {
                label: this.$t("inventory.storeQuantity") + ">0",
                key: 'lessNo',
                condition: { less: 'no' },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("inventory.lastInAt"),
            items: InventoryMms.lastInAts,
          },
          {
            label: this.$t("inventory.lastOutAt"),
            items: InventoryMms.lastOutAts,
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        serialNo: null,
        supplierId: null,
        shelf: null,
      },
      sorter: {
        sortBy: "inventories_id",
        sortIndicator: "desc",
      },
      suppliers: [],
      subjects: [],
      warehouses: [],
      userWarehouses: [],
      mmsAuthWarehouses: [],
      //
      row: null,
      currentRowId: null,
      currentRowIdx: null,
      editDF: false,
      // 快照
      exportAllDataDF: false,
      exportAllDataObj: { checkedWarehouseIds: [] },
      exportAllDataSubmitDoing: false,
      // 申请采购
      applyPurchaseDF: false,
      purchaseItems: [],
      applyPurchaseObj: {
        supplierId: null,
        supplierName: null,
        remark: null,
        procureItems: [],
      },
      applyPurchaseDoing: false,
      purchaseSupplierIds: [],
      selectDiffSupplierDF: false,
      // 编辑价格
      editPriceDF: false,
      editPriceObj: {
        price: null,
      },
      editPriceDoing: false,
      // 入库
      stockInDF: false,
      stockInObj: {
        inventoryId: null,
        quantity: null,
        remark: null,
      },
      stockInDoing: false,
      // 出库
      stockOutDF: false,
      stockOutObj: {
        inventoryId: null,
        quantity: null,
        remark: null,
      },
      stockOutDoing: false,
      // 编辑报警数量
      editDF: false,
      editObj: { alertQuantity: null, shelf: null, remark: null },
      editDoing: false,
      // 手动锁定库存
      updateManualLockQuantityDF: false,
      updateManualLockQuantityObj: {
        manualLockQuantity: null,
        remark: null,
      },
      updateManualLockQuantityDoing: false,
      // 调拨
      allocateDF: false,
      invWarehouses: [],
      allocateObj: {
        type: "in",
        serialNo: null,
        quantity: null,
        applyWarehouseId: null,
        applyWarehouseName: null,
        applyRemark: null,
        acceptWarehouseId: null,
        acceptWarehouseName: null,
        materialId: null,
        materialSerialNo: null,
        materialName: null,
        materialSubjectId: null,
        materialSubjectName: null,
        materialColor: null,
        materialColorNo: null,
        materialUnit: null,
        _applyMaxQty: null,
      },
      allocateDoing: false,
      //编辑备注
      row: null,
      currentRowIdx: null,
      editRemarkDF: false,
      editRemarkObj: {
        remark: null,
      },
      editRemarkDoing: false,
      //
      stockInOuts: [],
    };
  },

  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.loadingStart();
    axios
      .all([
        SubjectMms.findByTenantId(),
        SupplierMms.findByTenantId(),
        Warehouse.findByTenantId(),
        UserWarehouse.findByUserId(self.Permit.currentUser().id),
      ])
      .then(
        axios.spread(function (
          subjects,
          suppliers,
          warehouses,
          userWarehouses
        ) {
          if (subjects.status === 200) {
            if (self.Permit.currentUser().admin) {
              self.subjects = subjects.data;
            } else {
              self.subjects = subjects.data.filter((s) =>
                self.Permit.mmsAuthSubjuctIds().includes(s.id)
              );
            }
            self.narrowsSubjects();
          } else {
            self.sysError();
          }
          if (suppliers.status === 200) {
            self.suppliers = suppliers.data;
          } else {
            self.sysError();
          }
          self.warehouses = warehouses.data;
          self.userWarehouses = userWarehouses.data;
          if (self.Permit.currentUser().admin) {
            self.mmsAuthWarehouses = self.warehouses;
          } else {
            const userWarehouseIds = self.userWarehouses.map(
              (u) => u.warehouseId
            );
            self.mmsAuthWarehouses = self.warehouses.filter((w) =>
              userWarehouseIds.includes(w.id)
            );
          }
          self.narrowsWarehouses();
          self.loadingEnd();
        })
      );
  },
  methods: {
    getStockInOuts(row) {
      const self = this;
      StockInOutMms.findCashByInventoryId(row.id).then(function (res) {
        if (res.status === 200) {
          self.stockInOuts = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //编辑备注
    editRemark(row, rowIndex) {
      this.row = row;
      this.editRemarkObj.remark = row.remark;
      this.currentRowIdx = rowIndex;
      this.editRemarkDoing = false;
      this.editRemarkDF = true;
    },
    editRemarkSubmit() {
      const self = this;
      self.editRemarkDoing = true;
      InventoryMms.updateRemark(self.row.id, self.editRemarkObj).then(function (
        res
      ) {
        self.editRemarkDoing = false;
        self.editRemarkDF = false;
        if (res.status === 200) {
          self.records[self.currentRowIdx].remark = self.editRemarkObj.remark;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },

    //
    allocate(row, rowIndex) {
      const self = this;
      self.row = row;
      self.allocateObj.type = "in";
      self.allocateObj.serialNo = Util.serialNo();
      self.allocateObj.quantity = null;
      self.allocateObj.applyWarehouseId = row.warehouseId;
      self.allocateObj.applyWarehouseName = row.warehouseName;
      self.allocateObj.applyRemark = null;
      self.allocateObj.acceptWarehouseId = null;
      self.allocateObj.acceptWarehouseName = null;
      self.allocateObj.materialId = row.materialId;
      self.allocateObj.materialSerialNo = row.material.serialNo;
      self.allocateObj.materialName = row.material.name;
      self.allocateObj.materialSubjectId = row.material.subjectId;
      self.allocateObj.materialSubjectName = row.material.subjectName;
      self.allocateObj.materialColor = row.material.color;
      self.allocateObj.materialColorNo = row.material.colorNo;
      self.allocateObj.materialUnit = row.material.unit;
      self.allocateObj._applyMaxQty = null;
      self.selectAllocateType();
      self.allocateDF = true;
    },

    selectAllocateType() {
      const self = this;
      this.allocateObj.acceptWarehouseId = null;
      this.allocateObj.acceptWarehouseName = null;
      this.allocateObj.quantity = null;
      if (this.allocateObj.type === "in") {
        InventoryMms.findBySerialNos({
          serialNos: [self.allocateObj.materialSerialNo],
        }).then(function (res) {
          const invWarehouses = res.data;
          invWarehouses.forEach(
            (ii) =>
              (ii.text =
                ii.warehouseName +
                "(" +
                ii.storeQuantity +
                ii.material.unit +
                ")")
          );
          self.invWarehouses = invWarehouses.filter(
            (ii) => ii.warehouseId !== self.row.warehouseId
          );
        });
      } else {
        Warehouse.findByTenantId().then(function (res) {
          if (res.status === 200) {
            const invWarehouses = res.data.filter(
              (ii) => ii.id !== self.row.warehouseId
            );
            self.invWarehouses = invWarehouses.map((ii) => {
              return {
                text: ii.name,
                warehouseName: ii.name,
                warehouseId: ii.id,
              };
            });
          } else {
            self.sysError();
          }
        });
      }
    },
    blurAllocateQuantity() {
      const self = this;
      if (
        self.allocateObj.acceptWarehouseId != null &&
        self.allocateObj.quantity != null
      ) {
        if (self.allocateObj.type === "in") {
          const selectedInv = this.invWarehouses.find(
            (is) => is.warehouseId === self.allocateObj.acceptWarehouseId
          );
          self.allocateObj._applyMaxQty = selectedInv.storeQuantity;
        } else {
          self.allocateObj._applyMaxQty = self.row.storeQuantity;
        }
        if (self.allocateObj.quantity > self.allocateObj._applyMaxQty) {
          this.$message({
            message: self.$t("rules.beyondMaxQty", [
              self.allocateObj._applyMaxQty + self.allocateObj.materialUnit,
            ]),
            type: "warning",
          });
          self.allocateObj.quantity = null;
        }
      }
    },
    allocateSubmit() {
      const self = this;
      self.$refs.allocateForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(this.allocateObj.quantity)) {
            this.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          if (this.allocateObj.quantity > self.allocateObj._applyMaxQty) {
            this.$message({
              message: self.$t("rules.beyondMaxQty", [
                self.allocateObj._applyMaxQty + self.allocateObj.materialUnit,
              ]),
              type: "warning",
            });
            return;
          }
          self.allocateObj.acceptWarehouseName = self.invWarehouses.find(
            (is) => is.warehouseId === self.allocateObj.acceptWarehouseId
          ).warehouseName;
          self.allocateDoing = true;
          AllocateMms.create(self.allocateObj).then(function (res) {
            self.allocateDoing = false;
            self.allocateDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.applySuccess"),
                type: "success",
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 手动锁定库存
    updateManualLockQuantity(row) {
      const self = this;
      self.row = row;
      self.updateManualLockQuantityObj.manualLockQuantity =
        row.manualLockQuantity;
      self.updateManualLockQuantityObj.remark = row.manualLockRemark;
      self.updateManualLockQuantityDF = true;
    },
    updateManualLockQuantitySubmit() {
      const self = this;
      self.$refs.updateManualLockQuantityForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(
              this.updateManualLockQuantityObj.manualLockQuantity
            )
          ) {
            this.$message({
              message: self.$t("rules.regex", [
                self.$t("inventory.manualLockQuantity"),
              ]),
              type: "warning",
            });
            return;
          }
          self.updateManualLockQuantityDoing = true;
          InventoryMms.updateManualLockQuantity(
            self.row.id,
            self.updateManualLockQuantityObj
          ).then(function (res) {
            self.updateManualLockQuantityDoing = false;
            self.updateManualLockQuantityDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.updateManualLockQtySuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      InventoryMms.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑
    edit(row) {
      this.row = row;
      this.editObj.alertQuantity = row.alertQuantity;
      this.editObj.shelf = row.shelf;
      this.editObj.remark = row.remark;
      this.editDF = true;
    },
    // 库位
    querySearchShelfs(queryString, cb) {
      const self = this;
      InventoryMms.getShelfs({ warehouseId: self.row.warehouseId }).then(
        function (res) {
          const shelfs = res.data.map((item) => {
            return { value: item };
          });
          cb(shelfs);
        }
      );
    },
    handleSelectShelfs(item) {
      this.editObj.shelf = item.value;
    },
    editSubmit() {
      const self = this;
      self.$refs.editForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editObj.alertQuantity)) {
            this.$message({
              message: self.$t("rules.regex", [
                self.$t("inventory.alertQuantity"),
              ]),
              type: "warning",
            });
            return;
          }
          self.editDoing = true;
          InventoryMms.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 入库
    stockIn(row, rowIndex) {
      this.row = row;
      this.currentRowIdx = rowIndex;
      this.stockInObj.inventoryId = row.id;
      this.stockInObj.quantity = null;
      this.stockInObj.remark = null;
      this.stockInDF = true;
    },
    stockInSubmit() {
      const self = this;
      self.$refs.stockInForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.stockInObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.stockInDoing = true;
          InventoryMms.stockIn(self.stockInObj).then(function (res) {
            self.stockInDoing = false;
            self.stockInDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.stockInSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 出库
    stockOut(row, rowIndex) {
      this.row = row;
      this.currentRowIdx = rowIndex;
      this.stockOutObj.inventoryId = row.id;
      this.stockOutObj.quantity = null;
      this.stockOutObj.remark = null;
      this.stockOutDF = true;
    },

    stockOutSubmit() {
      const self = this;
      self.$refs.stockOutForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.stockOutObj.quantity) ||
            this.stockOutObj.quantity > this.row.storeQuantity
          ) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }

          self.stockOutDoing = true;
          InventoryMms.stockOut(self.stockOutObj).then(function (res) {
            self.stockOutDoing = false;
            self.stockOutDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.stockOutSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //编辑价格
    editPrice(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editPriceObj.price = row.price;
      self.editPriceDF = true;
      self.editPriceDoing = false;
    },
    editPriceSubmit() {
      const self = this;
      self.$refs.editPriceForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editPriceObj.price)) {
            this.$message({
              message: self.$t("rules.regex", [self.$t("inventory.price")]),
              type: "warning",
            });
            return;
          }
          self.editPriceDoing = true;
          InventoryMms.updatePrice(self.row.id, self.editPriceObj).then(
            function (res) {
              self.editPriceDoing = false;
              self.editPriceDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.records[self.currentRowIdx].price =
                  self.editPriceObj.price;
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    // 申请采购
    applyPurchase() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.applyPurchaseObj.supplierId = null;
      self.applyPurchaseObj.supplierName = null;
      self.applyPurchaseObj.remark = null;
      self.applyPurchaseObj.procureItems = [];
      self.selectDiffSupplierDF = false;
      self.purchaseSupplierIds = [];
      self.applyPurchaseObj.procureItems = self.selectRecords.map((c) => {
        return {
          materialId: c.materialId,
          image: c.material.image,
          materialSerialNo: c.material.serialNo,
          materialName: c.material.name,
          subjectId: c.material.subjectId,
          subjectName: c.material.subjectName,
          color: c.material.color,
          colorNo: c.material.colorNo,
          unit: c.material.inUnit,
          price: c.price * c.material.exchange,
          _supplierId: c.material.supplierId,
          _supplierName: c.material.supplierName,
          supplierId: null,
          supplierName: null,
          quantity: null,
          remark: null,
        };
      });
      self.judgeExistDiffSupplier();
      self.applyPurchaseDF = true;
    },
    removePurchaseItem(row, rowIndex) {
      const self = this;
      self.applyPurchaseObj.procureItems.splice(rowIndex, 1);
      self.judgeExistDiffSupplier();
    },
    judgeExistDiffSupplier() {
      const self = this;
      self.selectDiffSupplierDF = false;
      const filterPurchaseSupplierIds =
        self.applyPurchaseObj.procureItems.filter((p) => p._supplierId != null);
      self.purchaseSupplierIds = filterPurchaseSupplierIds.map(
        (i) => i._supplierId
      );
      const filtersSupplierIds = [...new Set(self.purchaseSupplierIds)];
      if (filtersSupplierIds.length > 1) {
        self.selectDiffSupplierDF = true;
      }
    },

    applyPurchaseSubmit() {
      const self = this;
      self.$refs.applyPurchaseForm.validate((valid) => {
        if (valid) {
          for (const i of self.applyPurchaseObj.procureItems) {
            if (!Util.regexQuantity(i.quantity)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("text.quantity")]),
                type: "warning",
              });
              return;
            }
            i.subjectId = self.applyPurchaseObj.supplierId;
            i.supplierName = self.suppliers.find(
              (s) => s.id === self.applyPurchaseObj.supplierId
            ).name;
          }
          self.applyPurchaseObj.supplierName = self.suppliers.find(
            (s) => s.id === self.applyPurchaseObj.supplierId
          ).name;
          self.applyPurchaseDoing = true;
          Procure.create(self.applyPurchaseObj).then(function (res) {
            self.applyPurchaseDoing = false;
            self.applyPurchaseDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.applySuccess"),
                type: "success",
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 快照
    exportAllData() {
      const self = this;
      self.exportAllDataObj.checkedWarehouseIds = [];
      self.exportAllDataSubmitDoing = false;
      if (self.mmsAuthWarehouses.length === 1) {
        self.exportAllDataObj.checkedWarehouseIds =
          self.mmsAuthWarehouses[0].id;
        self.exportAllDataSubmitFunction();
      } else {
        self.exportAllDataDF = true;
      }
    },
    exportAllDataSubmit() {
      const self = this;
      self.$refs.exportAllDataObjForm.validate((valid) => {
        if (valid) {
          self.exportAllDataSubmitFunction();
        } else {
          return false;
        }
      });
    },
    exportAllDataSubmitFunction() {
      const self = this;
      self.exportAllDataSubmitDoing = true;
      InventoryMms.exportQuickPhoto({
        warehouseIds: self.exportAllDataObj.checkedWarehouseIds,
      }).then(function (res) {
        self.exportAllDataSubmitDoing = false;
        self.exportAllDataDF = false;
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    narrowsSubjects() {
      const self = this;
      if (self.subjects.length != 0) {
        self.narrows.push([
          {
            label: self.$t("material.subject"),
            items: self.subjects.map((subject) => {
              return {
                label: subject.name,
                key: subject.id,
                condition: { subjectId: subject.id },
              };
            }),
          },
        ]);
      }
    },
    narrowsWarehouses() {
      const self = this;
      if (self.mmsAuthWarehouses.length != 0) {
        self.narrows.push([
          {
            label: self.$t("menu.warehouses"),
            items: self.mmsAuthWarehouses.map((warehouse) => {
              return {
                label: warehouse.name,
                key: warehouse.id,
                condition: { warehouseId: warehouse.id },
              };
            }),
          },
        ]);
      }
    },

    // 下载
    download(type) {
      const self = this;
      if (type == "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectRecords.map((c) => c.id),
        };
        self.downloadData(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      InventoryMms.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //
    dataProvider(params) {
      return InventoryMms.search(params);
    },
  },
};
</script>
